import { motion } from "framer-motion";
import { Link } from "wouter";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function Services() {
  const services = [
    {
      id: "web-design",
      title: "Web Design",
      description: "Our Company Variable Soft Is One of the Leading web design company in India. We Create Innovate Web Designs.",
      image: "/web-design-icon.png",
      features: ["Responsive Design", "Modern UI/UX", "Cross-browser Compatibility", "SEO Optimized"],
      link: "/webdesign"
    },
    {
      id: "web-development",
      title: "Web Development", 
      description: "We Develop Responsive Website Design Code To Perfect View From Monitors, Laptops, Tablets And Mobiles.",
      image: "/web-development-icon.png",
      features: ["Custom Development", "Responsive Framework", "Performance Optimization", "Security Focus"],
      link: "/software-development-in-jaipur"
    },
    {
      id: "ecommerce",
      title: "Ecommerce Development",
      description: "Variable soft Provides You An Excellent Tailor-Made & Customizable Ecommerce Solutions For Deployment And Development.",
      image: "/ecommerce-development-icon.png",
      features: ["Payment Integration", "Inventory Management", "Order Processing", "Multi-platform Support"],
      link: "/ecommerce-development-services"
    },
    {
      id: "mobile-app",
      title: "Mobile App Development",
      description: "Our Company Variable Soft Is One Of The Leading MOBILE Apps Development Company In India & Across.",
      image: "/mobile-app-development-icon.png",
      features: ["iOS & Android", "Native & Hybrid", "App Store Optimization", "Maintenance Support"],
      link: "/top-software-companies-in-jaipur"
    },
    {
      id: "seo",
      title: "Search Engine Optimization",
      description: "Variable Soft Provides You SEO Services That give you better and long lasting Results That Extend Beyond a quick Boost In Ranking.",
      image: "/seo-icon.png",
      features: ["Keyword Research", "On-page SEO", "Technical SEO", "Local SEO"],
      link: "/it-companies-in-jaipur"
    },
    {
      id: "software-development",
      title: "Software Development",
      description: "We build high quality software to make your business effortless. We're India-based, experience-rich team & leading software development company in India.",
      image: "/software-development-icon.png",
      features: ["Custom Software", "Enterprise Solutions", "API Development", "Legacy Modernization"],
      link: "/services/software-development"
    }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 overflow-x-hidden">
      <Navigation />
      
      {/* Hero Section */}
    <section className="relative overflow-hidden bg-[#050B1D] text-white py-28 font-roboto">
  {/* Enhanced Background */}
  <div className="absolute inset-0">
    <div className="absolute inset-0 bg-[radial-gradient(1200px_circle_at_20%_10%,rgba(59,130,246,0.26),transparent_55%),radial-gradient(900px_circle_at_85%_75%,rgba(14,165,233,0.20),transparent_55%),linear-gradient(to_bottom,rgba(2,6,23,0.90),rgba(2,6,23,1))]" />
    
    {/* Animated Grid Overlay */}
    <div className="absolute inset-0 opacity-10">
      <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                         linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px',
        maskImage: 'radial-gradient(circle at center, black 30%, transparent 70%)'
      }} />
    </div>
    
    {/* Floating Particles */}
    {[...Array(12)].map((_, i) => (
      <motion.div
        key={i}
        className="absolute w-1 h-1 bg-blue-400/20 rounded-full"
        initial={{
          x: Math.random() * 100 + 'vw',
          y: Math.random() * 100 + 'vh',
          opacity: 0
        }}
        animate={{
          x: [null, `calc(${Math.random() * 100}vw + ${Math.random() * 100 - 50}px)`],
          y: [null, `calc(${Math.random() * 100}vh + ${Math.random() * 100 - 50}px)`],
          opacity: [0, 0.3, 0]
        }}
        transition={{
          duration: Math.random() * 8 + 8,
          repeat: Infinity,
          repeatType: "reverse",
          delay: Math.random() * 5
        }}
      />
    ))}
    
    {/* Gradient Orbs */}
    <div className="absolute top-20 left-10 w-64 h-64 bg-blue-500/5 rounded-full blur-2xl animate-pulse" />
    <div className="absolute bottom-20 right-10 w-64 h-64 bg-cyan-500/5 rounded-full blur-2xl" />
  </div>

  <div className="container mx-auto px-4 md:px-6 relative z-10">
    {/* Animated Header */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="text-center mb-16"
    >
      {/* Decorative Line & Badge */}
      <div className="flex items-center justify-center gap-4 mb-6">
        <div className="w-12 h-px bg-gradient-to-r from-transparent via-blue-500 to-transparent" />
        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          className="px-4 py-1.5 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-full border border-blue-500/30 text-blue-400 font-semibold uppercase tracking-wider text-xs"
        >
          OUR CORE VALUES
        </motion.span>
        <div className="w-12 h-px bg-gradient-to-l from-transparent via-cyan-500 to-transparent" />
      </div>

      {/* Main Title with Gradient Text */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-4xl md:text-5xl font-bold mb-6 leading-tight"
      >
        What Drives{' '}
        <span className="relative inline-block">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-teal-400 animate-gradient bg-[length:200%_auto]">
            Us
          </span>
          {/* Text Shadow Glow */}
          <span className="absolute inset-0 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-teal-400 blur-lg opacity-30 animate-gradient bg-[length:200%_auto]">
            Us
          </span>
        </span>
      </motion.h1>

      {/* Description */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed"
      >
        Our core values define the way we work, ensuring that every project is executed with precision, creativity, and integrity.
      </motion.p>
    </motion.div>

    {/* Enhanced Cards Grid */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
      {[
        {
          title: "Innovation",
          description: "We continuously innovate to offer cutting-edge solutions that shape the future of technology.",
          icon: "fas fa-lightbulb",
          gradient: "from-purple-500 via-pink-500 to-orange-500",
          delay: 0.2
        },
        {
          title: "Quality",
          description: "We ensure the highest standards of quality in every project, from development to deployment.",
          icon: "fas fa-award",
          gradient: "from-blue-500 via-cyan-500 to-emerald-500",
          delay: 0.3
        },
        {
          title: "Collaboration",
          description: "We believe in the power of teamwork, working together with clients and partners to achieve mutual success.",
          icon: "fas fa-handshake",
          gradient: "from-indigo-500 via-blue-500 to-teal-400",
          delay: 0.4
        }
      ].map((value, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 40, rotateX: 10 }}
          animate={{ opacity: 1, y: 0, rotateX: 0 }}
          transition={{ 
            duration: 0.6, 
            delay: value.delay,
            ease: "backOut"
          }}
          whileHover={{ 
            y: -8,
            rotateX: 3,
            transition: { 
              duration: 0.2,
              type: "spring",
              stiffness: 300
            }
          }}
          className="relative group perspective-1000"
        >
          {/* Glow Effect */}
          <div className={`absolute -inset-0.5 bg-gradient-to-r ${value.gradient} rounded-2xl blur-lg opacity-15 group-hover:opacity-25 transition-all duration-300`} />
          
          {/* Card Container */}
          <div className="relative h-full bg-gradient-to-br from-slate-900/80 to-slate-800/40 backdrop-blur-xl rounded-2xl border border-slate-700/50 p-6 overflow-hidden group-hover:border-slate-600/60 transition-all duration-200">
            
            {/* Animated Background Pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.3),transparent_50%)]" />
            </div>
            
            {/* Icon Container */}
            <motion.div
              whileHover={{ rotateY: 180, scale: 1.05 }}
              transition={{ duration: 0.4, type: "spring" }}
              className={`relative w-14 h-14 bg-gradient-to-br ${value.gradient} rounded-xl flex items-center justify-center mb-6 mx-auto shadow-lg shadow-blue-500/10 group-hover:shadow-blue-500/20 transition-all duration-200`}
            >
              <i className={`${value.icon} text-white text-lg absolute`} />
              <div className="absolute inset-0 bg-gradient-to-br ${value.gradient} rounded-xl blur-md opacity-30" />
              
              {/* Floating Particles around icon */}
              {[...Array(4)].map((_, i) => (
                <motion.div
                  key={i}
                  className="absolute w-0.5 h-0.5 bg-white rounded-full"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: [0, 0.8, 0] }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    delay: i * 0.4,
                    repeatDelay: 1.5
                  }}
                  style={{
                    left: `${Math.cos(i * 90) * 35}%`,
                    top: `${Math.sin(i * 90) * 35}%`
                  }}
                />
              ))}
            </motion.div>
            
            {/* Title */}
            <h3 className="text-xl font-bold text-center mb-4 relative">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300">
                {value.title}
              </span>
              <motion.span
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ delay: value.delay + 0.2, duration: 0.6 }}
                className="block h-0.5 bg-gradient-to-r from-transparent via-slate-600 to-transparent mt-3 group-hover:via-blue-500 transition-all duration-200"
              />
            </h3>
            
            {/* Description */}
            <p className="text-slate-300 text-center text-sm leading-relaxed">
              {value.description}
            </p>
            
            {/* Bottom Gradient Accent */}
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300" />
            
            {/* Corner Decorations */}
            <div className="absolute top-3 right-3 w-2 h-2 border-t border-r border-blue-400/30 rounded-tr-md" />
            <div className="absolute bottom-3 left-3 w-2 h-2 border-b border-l border-cyan-400/30 rounded-bl-md" />
            
            {/* Hover Effect Overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/3 to-cyan-500/3 opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-2xl" />
          </div>
          
          {/* Floating Label */}
          <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2">
            <div className="px-3 py-0.5 bg-gradient-to-r from-blue-900/70 to-cyan-900/70 backdrop-blur-sm rounded-full border border-blue-500/20">
              <span className="text-xs text-blue-300 font-semibold tracking-wider">
                Value {index + 1}
              </span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>

    {/* Animated Divider */}
    <motion.div
      initial={{ opacity: 0, width: 0 }}
      animate={{ opacity: 1, width: "100%" }}
      transition={{ delay: 0.8, duration: 1 }}
      className="relative mt-12 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"
    >
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <motion.div
          animate={{ 
            rotate: 360,
            scale: [1, 1.1, 1]
          }}
          transition={{
            rotate: { duration: 3, repeat: Infinity, ease: "linear" },
            scale: { duration: 1.5, repeat: Infinity }
          }}
          className="w-3 h-3 border-2 border-blue-500/40 rounded-full"
        >
          <div className="w-0.5 h-0.5 bg-blue-400 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </motion.div>
      </div>
    </motion.div>
  </div>
</section>

      {/* Services Grid */}
<section
  className="relative py-20 bg-white overflow-hidden"
  style={{ fontFamily: "'Roboto', sans-serif" }}
>
  {/* ENHANCED BACKGROUND WITH PATTERN */}
  <div className="absolute inset-0">
    {/* Gradient Background */}
    <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50/30" />
    
    {/* Geometric Pattern */}
    <div className="absolute inset-0 opacity-[0.18]
      [background-image:radial-gradient(circle_at_1px_1px,rgba(2,6,23,0.15)_1px,transparent_0)]
      [background-size:28px_28px]" />
    
    {/* Animated Gradient Orbs */}
    <div className="absolute top-20 left-1/4 w-80 h-80 bg-gradient-to-r from-blue-500/10 to-cyan-400/10 rounded-full blur-2xl animate-pulse" />
    <div className="absolute bottom-20 right-1/4 w-80 h-80 bg-gradient-to-r from-indigo-400/5 to-purple-400/5 rounded-full blur-2xl" />
    
    {/* Floating Particles */}
    {[...Array(10)].map((_, i) => (
      <motion.div
        key={i}
        className="absolute w-1 h-1 bg-blue-400/20 rounded-full"
        initial={{
          x: Math.random() * 100 + 'vw',
          y: Math.random() * 100 + 'vh',
          opacity: 0
        }}
        animate={{
          x: [null, `calc(${Math.random() * 100}vw + ${Math.random() * 100 - 50}px)`],
          y: [null, `calc(${Math.random() * 100}vh + ${Math.random() * 100 - 50}px)`],
          opacity: [0, 0.2, 0]
        }}
        transition={{
          duration: Math.random() * 6 + 6,
          repeat: Infinity,
          repeatType: "reverse",
          delay: Math.random() * 3
        }}
      />
    ))}
  </div>

  <div className="relative container mx-auto px-4 md:px-6">
    {/* Enhanced Header with Animation */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="text-center mb-16 max-w-3xl mx-auto"
    >
      {/* Badge */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="inline-flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-full border border-blue-200 mb-4"
      >
        <div className="w-1.5 h-1.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full"></div>
        <span className="text-xs font-semibold text-gradient bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
          Our Premium Services
        </span>
      </motion.div>

      {/* Main Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-3xl md:text-4xl  lg:text-5xl font-bold text-slate-900 mb-4 leading-tight"
      >
        Transform Your{' '}
        <span className="relative inline-block">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-cyan-500 to-teal-500 animate-gradient bg-[length:200%_auto]">
            Digital Presence
          </span>
          <span className="absolute inset-0 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-cyan-500 to-teal-500 blur-lg opacity-30 animate-gradient bg-[length:200%_auto]">
            Digital Presence
          </span>
        </span>
      </motion.h2>

      {/* Subtitle */}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="text-base text-slate-600 leading-relaxed"
      >
        We deliver cutting-edge solutions that drive growth, innovation, and success for your business
      </motion.p>
    </motion.div>

    {/* Enhanced Services Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
      {services.map((service, index) => (
        <motion.div
          key={service.id}
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ 
            duration: 0.6, 
            delay: index * 0.1,
            ease: "backOut"
          }}
          whileHover={{ 
            y: -8,
            scale: 1.01,
            transition: { 
              duration: 0.2,
              type: "spring",
              stiffness: 300
            }
          }}
          viewport={{ once: true }}
          className="group relative perspective-1000"
        >
          {/* Glow Effect */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500/20 via-cyan-400/20 to-teal-400/20 rounded-2xl blur-lg opacity-0 group-hover:opacity-20 transition-all duration-300" />
          
          {/* Main Card */}
          <Link href={service.link}>
            <div className="relative h-full bg-gradient-to-br from-white to-slate-50 rounded-2xl p-6 border border-slate-100 shadow-lg shadow-blue-500/5 group-hover:shadow-xl group-hover:shadow-blue-500/10 transition-all duration-300 overflow-hidden">
              
              {/* Animated Background Lines */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                  backgroundImage: `linear-gradient(90deg, transparent 95%, rgba(59,130,246,0.3) 100%)`,
                  backgroundSize: '20px 100%'
                }} />
              </div>
              
              {/* Corner Accents */}
              <div className="absolute top-3 right-3 w-6 h-6 border-t border-r border-blue-300/30 rounded-tr-lg" />
              <div className="absolute bottom-3 left-3 w-6 h-6 border-b border-l border-cyan-300/30 rounded-bl-lg" />
              
              {/* Icon Container with Advanced Effects */}
              <motion.div
                whileHover={{ scale: 1.1, rotateY: 180 }}
                transition={{ type: "spring", stiffness: 300, damping: 10 }}
                className="relative z-10 flex items-center justify-center w-16 h-16 rounded-xl mb-6 mx-auto shadow-md shadow-blue-500/10 group-hover:shadow-lg group-hover:shadow-blue-500/20 transition-all duration-300"
              >
                {/* Icon Background with Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl" />
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl blur-md opacity-50" />
                
                {/* Icon Image */}
                <div className="relative z-10 p-3 bg-white/10 backdrop-blur-sm rounded-lg">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-8 h-8 drop-shadow-md"
                  />
                </div>
                
                {/* Floating Particles */}
                {[...Array(3)].map((_, i) => (
                  <motion.div
                    key={i}
                    className="absolute w-0.5 h-0.5 bg-white rounded-full"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: [0, 0.8, 0] }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      delay: i * 0.5,
                      repeatDelay: 1
                    }}
                    style={{
                      left: `${Math.cos(i * 120) * 50}%`,
                      top: `${Math.sin(i * 120) * 50}%`
                    }}
                  />
                ))}
              </motion.div>
              
              {/* Title with Gradient Hover Effect */}
              <h3 className="relative z-10 text-xl font-bold text-slate-900 mb-4 text-center group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-cyan-600 group-hover:bg-clip-text transition-all duration-300">
                {service.title}
                <motion.span
                  initial={{ width: 0 }}
                  whileInView={{ width: "30px" }}
                  transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
                  className="block h-0.5 bg-gradient-to-r from-blue-300 to-cyan-300 rounded-full mt-2 mx-auto"
                />
              </h3>
              
              {/* Description */}
              <p className="relative z-10 text-sm text-slate-600 leading-relaxed mb-6 text-center">
                {service.description}
              </p>
              
              {/* Features List with Enhanced Icons */}
              <ul className="relative z-10 space-y-3 mb-8">
                {service.features.map((feature, featureIndex) => (
                  <motion.li
                    key={featureIndex}
                    initial={{ opacity: 0, x: -15 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 + featureIndex * 0.08 }}
                    className="flex items-center text-slate-700 group/feature"
                  >
                    <div className="relative flex-shrink-0 mr-3">
                      <div className="w-6 h-6 rounded-full bg-gradient-to-r from-blue-500/10 to-cyan-500/10 flex items-center justify-center group-hover/feature:from-blue-500/15 group-hover/feature:to-cyan-500/15 transition-all duration-300">
                        <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500" />
                      </div>
                      <div className="absolute inset-0 w-6 h-6 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 blur-sm opacity-0 group-hover/feature:opacity-20 transition-opacity duration-300" />
                    </div>
                    <span className="text-xs font-medium group-hover/feature:text-slate-900 transition-colors duration-300">
                      {feature}
                    </span>
                  </motion.li>
                ))}
              </ul>
              
              {/* Enhanced CTA Button */}
              <div className="relative z-10 flex items-center justify-center gap-2 text-blue-600 font-semibold group/cta">
                <span className="text-sm group-hover/cta:text-transparent group-hover/cta:bg-gradient-to-r group-hover/cta:from-blue-600 group-hover/cta:to-cyan-600 group-hover/cta:bg-clip-text transition-all duration-300">
                  Discover More
                </span>
                <div className="relative w-6 h-6 rounded-full bg-gradient-to-r from-blue-500/10 to-cyan-500/10 flex items-center justify-center group-hover/cta:from-blue-500/15 group-hover/cta:to-cyan-500/15 transition-all duration-300">
                  <motion.i
                    className="fas fa-arrow-right text-blue-500 text-xs"
                    animate={{ x: [0, 3, 0] }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      repeatDelay: 1
                    }}
                  />
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 blur-sm opacity-0 group-hover/cta:opacity-20 transition-opacity duration-300" />
                </div>
              </div>
              
              {/* Bottom Gradient Accent */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-blue-300 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300" />
              
              {/* Hover Overlay Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl" />
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  </div>
</section>

      {/* Working Principles */}
<section className="relative overflow-hidden bg-[#050B1D] text-white py-20 font-roboto">
  {/* Background Effects */}
  <div className="absolute inset-0">
    <div className="absolute inset-0 bg-[radial-gradient(1200px_circle_at_20%_10%,rgba(59,130,246,0.26),transparent_55%),radial-gradient(900px_circle_at_85%_75%,rgba(14,165,233,0.20),transparent_55%),linear-gradient(to_bottom,rgba(2,6,23,0.90),rgba(2,6,23,1))]" />
    
    {/* Animated grid background */}
    <div className="absolute inset-0 opacity-5">
      <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                         linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
        backgroundSize: '50px 50px',
        maskImage: 'radial-gradient(circle at center, black, transparent 70%)'
      }}></div>
    </div>
    
    {/* Floating elements */}
    <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-2xl animate-pulse"></div>
    <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-cyan-500/5 rounded-full blur-2xl"></div>
  </div>

  <div className="container mx-auto px-6 relative z-10">
    {/* Header Section */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, margin: "-100px" }}
      className="text-center mb-16"
    >
      <div className="inline-flex items-center justify-center gap-8 mb-6">
        <div className="w-12 h-px bg-gradient-to-r from-transparent to-blue-500"></div>
        <span className="text-blue-400 font-semibold tracking-wider text-sm uppercase">
          Our Philosophy
        </span>
        <div className="w-12 h-px bg-gradient-to-l from-transparent to-cyan-500"></div>
      </div>
      
      <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
        Our Working <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">Principles</span>
      </h2>
      
      <p className="text-lg text-slate-300 max-w-3xl mx-auto leading-relaxed">
        These core principles guide everything we do, ensuring we deliver exceptional results for every project.
      </p>
    </motion.div>

    {/* Principles Grid */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
      {[
        {
          title: "High Quality",
          description: "Our professional developers always try to provide you high quality software with low failure risk. We are trying to provide you 100% risk free software for your business.",
          icon: "fas fa-star",
          gradient: "from-yellow-500 to-orange-500",
          delay: 0.1
        },
        {
          title: "User-Friendliness & Usability",
          description: "We keep in mind end users at the time of developing software. We are designing and developing softwares according to end users so that they can use it and produce 100% productivity.",
          icon: "fas fa-users",
          gradient: "from-blue-500 to-cyan-500",
          delay: 0.2
        },
        {
          title: "Security of Data & Information",
          description: "Our keen motive is to keep safe your company data and information. We are not losing any point regarding security in our development process. We assured security of your data on each and every step.",
          icon: "fas fa-shield-alt",
          gradient: "from-green-500 to-emerald-500",
          delay: 0.3
        },
        {
          title: "Flawless Backend Integration",
          description: "Our developers are always focusing on developing error free software. We are always providing best backend integration that will provide you smooth running your system and increase your productivity.",
          icon: "fas fa-cogs",
          gradient: "from-purple-500 to-pink-500",
          delay: 0.4
        }
      ].map((principle, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ 
            duration: 0.6, 
            delay: principle.delay,
            ease: "easeOut"
          }}
          viewport={{ once: true, margin: "-50px" }}
          whileHover={{ 
            y: -8,
            transition: { duration: 0.3 }
          }}
          className="group relative"
        >
          {/* Card Glow Effect */}
          <div className={`absolute -inset-0.5 bg-gradient-to-r ${principle.gradient} rounded-2xl blur opacity-15 group-hover:opacity-30 transition duration-300`}></div>
          
          {/* Card */}
          <div className="relative bg-slate-900/70 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-6 h-full hover:border-slate-600/50 transition-all duration-300">
            {/* Icon Container */}
            <motion.div
              whileHover={{ rotate: 5, scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
              className={`relative w-16 h-16 bg-gradient-to-br ${principle.gradient} rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-blue-500/10 group-hover:shadow-blue-500/20 transition-all duration-300`}
            >
              <i className={`${principle.icon} text-white text-xl`}></i>
              
              {/* Icon Glow */}
              <div className="absolute inset-0 bg-gradient-to-br ${principle.gradient} rounded-xl blur-md opacity-30"></div>
            </motion.div>
            
            {/* Title */}
            <h3 className="text-xl font-bold mb-4 flex items-center gap-3">
              {principle.title}
              <motion.span
                initial={{ width: 0 }}
                whileInView={{ width: 30 }}
                transition={{ delay: principle.delay + 0.3, duration: 0.4 }}
                className="h-px bg-gradient-to-r from-slate-600 to-transparent"
              ></motion.span>
            </h3>
            
            {/* Description */}
            <p className="text-slate-300 leading-relaxed text-base">
              {principle.description}
            </p>
            
            {/* Hover Line Effect */}
            <div className="absolute bottom-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent group-hover:via-blue-500 transition-all duration-300"></div>
            
            {/* Corner Accents */}
            <div className="absolute top-3 right-3 w-2 h-2 border-t border-r border-blue-500/30 rounded-tr-md"></div>
            <div className="absolute bottom-3 left-3 w-2 h-2 border-b border-l border-cyan-500/30 rounded-bl-md"></div>
          </div>
        </motion.div>
      ))}
    </div>

    {/* Decorative Elements */}
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.8 }}
      className="flex justify-center items-center gap-4 mt-12"
    >
      {[...Array(3)].map((_, i) => (
        <motion.div
          key={i}
          animate={{ y: [0, -8, 0] }}
          transition={{
            duration: 2,
            delay: i * 0.2,
            repeat: Infinity,
            repeatType: "reverse"
          }}
          className="w-1.5 h-1.5 bg-blue-400 rounded-full"
        ></motion.div>
      ))}
    </motion.div>
  </div>
</section>

      <Footer />
    </div>
  );
}